import { render, staticRenderFns } from "./SurveyResultPreview.vue?vue&type=template&id=61927e8f&scoped=true"
import script from "./SurveyResultPreview.vue?vue&type=script&lang=js"
export * from "./SurveyResultPreview.vue?vue&type=script&lang=js"
import style0 from "./SurveyResultPreview.vue?vue&type=style&index=0&id=61927e8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61927e8f",
  null
  
)

export default component.exports